import React, { Component } from 'react'

import {
  RadioGroup,
  Icon,
  Pill,
  ButtonAction,
  Select,
  Tooltip,
  FormGroup,
  Input
} from "xsolla-uikit";

import SelectExample from "./SelectExample";
import SwitchExample from "./SwitchExample";



export default class PAInputUpgrades extends Component {

  constructor(props) {
    super(props)
    this.handeCurrDel = props.handeCurrDel || null;
    this.id = props.id || null;
    this.add = props.add || false;
    this.value = props.value || 'SKU';

    this.state = {
      curr: props.curr || "usd",
      platform: props.platform || "All platforms",
      price: props.price || 0,
    }
  }

  handleInput = (e: SyntheticInputEvent<HTMLInputElement>) => this.setState({price: e.target.value});


  render(

  ) {
    return (

    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
      <div className="xsui-form-group__entry">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
            <div style={{
              width: "66%",
              justifyContent: 'flex-start',
              alignItems: 'center',
              display: 'flex',
            }}>
              <div
                className="xsui-form-group--direction-column"
              style={{
                // position: "relative",
                display: "flex",
                flexDirection: 'row',
                flexBasis: 'center',
                flexAlign: 'center',
                width: "100%",
              }}
              >
                <div
                  className={(this.state.price && this.state.price !== '0') ? "xsui-pill xsui-pill--appearance-active" : "xsui-pill xsui-pill--appearance-cancelled"}
                  style={{marginRight: 8}}
                >
                  <Icon name={(this.state.price && this.state.price !== '0') ? "checkmark-mini" : "exclamation-mini"}/>
                </div>

                <div className="xsui-switch__label">
                  {this.value}
                </div>

            </div>
          </div>


          {/* <div style={{
            width: "33%",
            flexShrink: 0,
            zIndex: "3"
          }}>
                <SelectExample
                  // title="Currency"
                  canBeEmpty={false}
                  size="md"
                  defaultValue={2}
                  options={[
                    { label: "All Currencies", value: "all" },
                    { label: "USD", value: "USD" },
                    { label: "EUR", value: "EUR" },
                    { label: "RUB", value: "EUR" },
                  ]}
                />
            </div> */}


          <div style={{ width: "32%" }}>
            <div
              style={{
                // position: "relative",
                width: "100%",
                display: "block"
              }}
            >

        <FormGroup label="" indentation="lg">
          <Input
                  input={{
                    name: 'with-icon',
                      value: this.state.price,
                    size: 'xs',
                    // extraLabel: this.currLocked ? "DEFAULT" : null
                      onChange: this.handleInput
                    }}
                    size='sm'
                    offset="right"
                    //   extra={
                    //     <Icon
                    //       name={this.currLocked ? "null" : "delete"}
                    //       hoverable={true}
                    //       onClick={e => this.handeCurrDel(this.id, e)}
                    // />}
          />
        </FormGroup>


              {/* <ButtonAction
                style={{ paddingLeft: "2%" }}
                autosize={false}
                  appearance="filled"
                  extraLabel={this.currLocked ? "DEFAULT" : null}
                  icon={this.currLocked ? "null" : "delete"}
                  children={price}
                  style={{ paddingLeft: 8 }}
                  onClick={e => handeCurrDel(id, e)}
                /> */}
            </div>
          </div>
        </div>
      </div>
    </div>




    )
  }
}
